export const T = {
  en_GB: {
    notAvailable: "Cost data is not available. Please ensure all goals have been processed.",
    snapshotMissingMessage:
      "Aggregate cost data needs to be regenerated. Use the Regenerate button above.",
    errorLoading: "Error loading cost data. Please refresh the page.",
    unavailable: "Cost Data Unavailable",
    contactAdvisor: "Please contact your advisor for assistance.",
  },
  nb_NO: {
    notAvailable: "Kostnadsdata er ikke tilgjengelig. Kontroller at alle mål er behandlet.",
    snapshotMissingMessage: "Aggregert kostnadsdata må regenereres. Bruk Regenerer-knappen over.",
    errorLoading: "Feil ved lasting av kostnadsdata. Oppdater siden.",
    unavailable: "Kostnadsdata ikke tilgjengelig",
    contactAdvisor: "Kontakt din rådgiver for hjelp.",
  },
} as const;
